import { connect } from 'react-redux';
import { getProjectUrl, isCollaborator } from 'project/utils';
import { getProject, toggleViolationModal } from 'project/ducks/project';
import { getSubcategorySlug } from 'common/ducks/categories';
import {
  canComment, canTip, canOffer, canRemoveCreative, canWithdraw, canEliminate, canUnwithdraw,
  canUneliminate, canReportViolation, canShare
} from 'entries/utils';
import { getAwards, toggleTip, toggleOffer, toggleDelete, toggleReinstate } from 'entries/ducks';
import { toggleRemoveModal } from 'project/ducks/creatives';
import ActionsMenu from 'entries/components/actions_menu';

const mapStateToProps = (state, { entry }) => {
  const user = state.user.profile_data;
  const project = getProject(state);
  const subcatSlug = getSubcategorySlug(state.categories, project.sub_category);
  const detailsUrl = getProjectUrl(project, subcatSlug, `entry/${entry.id}/`);
  const availableAwards = getAwards(state, true);
  const isOwnerOrCollab = user.id === project.client || isCollaborator(project);

  return {
    canComment: canComment({ project, entry, user }),
    canTip: canTip({ project, entry, user, availableAwards }),
    canOffer: canOffer({ project, entry, user, availableAwards }),
    canViewCreative: isOwnerOrCollab,
    canRemoveCreative: canRemoveCreative({ project, user }),
    canWithdraw: canWithdraw({ entry, user }),
    canEliminate: canEliminate({ entry, user, project }),
    canUnwithdraw: canUnwithdraw({ entry, user }),
    canUneliminate: canUneliminate({ entry, user, project }),
    canReportViolation: canReportViolation({ entry, user, project }),
    canShare: canShare({ entry, user, project }),
    detailsUrl
  };
}

export default connect(mapStateToProps, {
  toggleTip,
  toggleOffer,
  toggleDelete,
  toggleReinstate,
  toggleViolationModal,
  toggleRemoveCreative: toggleRemoveModal
})(ActionsMenu);



// WEBPACK FOOTER //
// ./entries/containers/actions_menu.js